import React from 'react';
import {Box, Typography} from '@mui/material';
import ArrButton from '../../../common/arr-button/ArrButton';
import './WidgetsHeader.scss';

type WidgetsHeaderProps = {
  mainTitle?: string;
  subTitle: string;
  isSaveDisabled?: boolean;
  isCancelDisabled?: boolean;
  onSave: () => void;
  onCancel: () => void;
};

export const WidgetsHeader: React.FC<WidgetsHeaderProps> = ({
  mainTitle,
  subTitle,
  isSaveDisabled = false,
  isCancelDisabled = false,
  onSave,
  onCancel,
}) => {
  return (
    <Box className="header-box">
      <Typography
        className="typo-text subhead5_size title"
        data-testid={`widget-header-title`}
      >
        {mainTitle}
      </Typography>
      <Box className="title-box">
        <Typography
          className="typo-text headline2_size title"
          data-testid={`widget-header-subtitle`}
        >
          {subTitle}
        </Typography>

        <Box className="action-buttons-box">
          <ArrButton
            variant="secondary"
            size="medium"
            onClick={onCancel}
            disabled={isCancelDisabled}
            dataTestId="widgets-header-cancel-button"
          >
            Cancel
          </ArrButton>

          <ArrButton
            variant="primary"
            size="medium"
            onClick={onSave}
            disabled={isSaveDisabled}
            dataTestId="save-button"
          >
            Save
          </ArrButton>
        </Box>
      </Box>
    </Box>
  );
};
